import React, { useEffect, useState } from 'react'
import { UserProfileData } from '../modals/user-table-info/modal-sectors/common-components/UserProfileData'
import { UserContactData } from '../modals/user-table-info/modal-sectors/common-components/UserContactData'
import { CustomFormFloating } from '../custom-form-floating/CustomFormFloating'
import { CloseButtonModal } from '../modals/user-table-info/modal-sectors/CloseButtonModal'
import logger from '../../../utils/logger'
import { useSelector } from 'react-redux'
import './userDetailModal.css'



export const UserDetailModal = ({ userData, toggleModal }) => {

    const list = useSelector((data) => data)


    logger.debug('UserDetailModal redux list: ', list)

    const getProfession = (id) => {

        if (!list) return;

        const userProfession = list.commonData.lista?.professions.find(p => p.id === id);


        return userProfession?.name;
    }

    const getDocumentType = (id) => {

        if (!list) return;

        const documentType = list.commonData.lista?.documentTypes.find(p => p.id === id);


        return documentType?.description;

    }


    // const [userData, setuserData] = useState(null)

    // useEffect(() => {

    //     if (userData) {
    //         setuserData(userData.userData)
    //     }

    // }, [userData])

    // logger.debug('userData es: ', userData)


    return (
        <div className="modal-content udm-contentWidht">

            <div className="modal-body mbody-class">

                <div id="content-1" className={`dto-contacto  content active `}>


                    <CloseButtonModal toggleModal={toggleModal} />


                    <div className="header-dto">
                        <h4 className="header-nav-title">Datos de contacto</h4>

                        <UserProfileData
                            userInfo={userData}
                            
                        />


                        <UserContactData
                            userInfo={userData}
                            emailAction='email'
                            
                        >
                            
                        </UserContactData>




                    </div>

                    <hr className="under-header" />



                    <div className="user-dto fc-user-dto">

                        {userData?.documentTypeId
                            &&
                            <CustomFormFloating
                                status={false}
                                type={'Tipo de Documento'}
                                className={'editable-admin-input w-100'}
                                label={'Nro de Documento'}
                                labelClassName={'active-label'}
                                hrtag={'hr-dto'}
                                value={getDocumentType(userData.documentTypeId)}
                                readOnly
                            >

                            </CustomFormFloating>
                        }




                        {userData?.dni &&
                            <CustomFormFloating
                                status={false}
                                type={'text'}
                                className={'editable-admin-input w-100'}
                                label={'Nro de Documento'}
                                labelClassName={'active-label'}
                                hrtag={'hr-dto'}
                                value={userData.dni}
                                readOnly
                            >

                            </CustomFormFloating>
                        }



                        {userData?.professionId &&

                            <CustomFormFloating
                                status={false}
                                type={'text'}
                                className={'editable-admin-input w-100'}
                                label={'Profesión'}
                                labelClassName={'active-label'}
                                hrtag={'hr-dto'}
                                value={getProfession(userData.professionId)}
                                readOnly
                            >

                            </CustomFormFloating>
                        }


                        {userData?.professionalLicense &&
                            <CustomFormFloating
                                status={false}
                                type={'text'}
                                className={'editable-admin-input w-100'}
                                label={'MP'}
                                labelClassName={'active-label'}
                                hrtag={'hr-dto'}
                                value={userData.professionalLicense}
                                readOnly
                            >


                            </CustomFormFloating>
                        }

                        {userData?.address &&
                            <CustomFormFloating
                                status={false}
                                type={'text'}
                                className={'editable-admin-input w-100'}
                                label={'Dirección'}
                                labelClassName={'active-label'}
                                hrtag={'hr-dto'}
                                value={userData.address}
                                readOnly
                            >


                            </CustomFormFloating>
                        }



                        {userData?.zipCode &&
                            <CustomFormFloating
                                status={false}
                                type={'text'}
                                className={'editable-admin-input w-100'}
                                label={'Código Postal'}
                                labelClassName={'active-label'}
                                hrtag={'hr-dto'}
                                value={userData.zipCode}
                                readOnly
                            >


                            </CustomFormFloating>
                        }


                        {userData?.addressAdditionalData &&
                            <CustomFormFloating
                                status={false}
                                type={'text'}
                                className={'editable-admin-input w-100'}
                                label={'Barrio'}
                                labelClassName={'active-label'}
                                hrtag={'hr-dto'}
                                value={userData.addressAdditionalData}
                                readOnly
                            >


                            </CustomFormFloating>
                        }


                        {userData?.city &&
                            <CustomFormFloating
                                status={false}
                                type={'text'}
                                className={'editable-admin-input w-100'}
                                label={'Localidad'}
                                labelClassName={'active-label'}
                                hrtag={'hr-dto'}
                                value={userData.city}
                                readOnly
                            >


                            </CustomFormFloating>
                        }




                        {userData?.province &&
                            <CustomFormFloating
                                status={false}
                                type={'text'}
                                className={'editable-admin-input w-100'}
                                label={'Provincia'}
                                labelClassName={'active-label'}
                                hrtag={'hr-dto'}
                                value={userData.province}
                                readOnly
                            >


                            </CustomFormFloating>
                        }


                        {userData?.country &&
                            <CustomFormFloating
                                status={false}
                                type={'text'}
                                className={'editable-admin-input w-100'}
                                label={'País'}
                                labelClassName={'active-label'}
                                hrtag={'hr-dto'}
                                value={userData.country}
                                readOnly
                            >


                            </CustomFormFloating>
                        }



                    </div>





                </div>



            </div>
        </div>
    )
}
